export type PropertyId = string & { readonly __brand: 'PropertyId' };

export function definePropertyId(name: string): PropertyId {
    return name as PropertyId;
}

// Dynamic ids are only unique within the PropertyList that created them (see PropertyList.createDynamicId).
// The "dyn:" prefix keeps them visibly distinct from statically-declared ids.
export function createDynamicPropertyId(counter: number): PropertyId {
    return `dyn:${counter}` as PropertyId;
}
